
import { AM_URL, APP_URL_FORGEROCK, FORGEROCK_AUTH_INDEX_TYPE, FORGEROCK_DIGITALSPA_FLOW, FORGEROCK_SCOPE, FORGEROCK_SPA_AUTH_INDEX_VALUE, REALM_PATH, WEB_OAUTH_CLIENT, FORGEROCK_SERVER_CONFIG_TIMEOUT } from '@/config/constants';
import { Config, TokenManager, TokenStorage } from '@forgerock/javascript-sdk';
import { updateUserDetail } from '@/reducers/user/userSlice';
import { store } from '@/store/configureStore';
import axios from 'axios';

const getRedirectUrl = ()=>{
  const isLiveSit = process.env.NEXT_PUBLIC_APP_BASE_URL === '/livesit' && process.env.NODE_ENV === "production"
  if(isLiveSit){
    // temp fix for trying out some feature
    return 'https://livesit.aldar.com/api/dummy'
  } else {
    return  `${APP_URL_FORGEROCK}`
  }
}

export const setForgerockConfig = (tree: string) => {
  Config.set(
    {
      clientId: WEB_OAUTH_CLIENT,
      redirectUri: getRedirectUrl(),
      scope: `${FORGEROCK_SCOPE}`,
      serverConfig: {
        baseUrl: `${AM_URL}`,
        timeout: Number(FORGEROCK_SERVER_CONFIG_TIMEOUT),
      },
      realmPath: REALM_PATH,
      tree: tree,
    }
  );
}

const decodeJwtPayload = (jwt: string): { exp?: number; iat?: number } => {
  try {
    return JSON.parse(atob(jwt.split('.')[1]));
  } catch {
    return {};
  }
};

export const extractTokenTiming = (tokens: any): { tokenIssuedAt: number; tokenExpiresAt: number } => {
  const now = Date.now();
  const jwtSource = tokens?.accessToken;
  if (jwtSource) {
    const claims = decodeJwtPayload(jwtSource);
    if (claims.exp && claims.iat) {
      return { tokenIssuedAt: claims.iat * 1000, tokenExpiresAt: claims.exp * 1000 };
    }
  }
  // Fallback: assume 1-hour lifetime
  return { tokenIssuedAt: now, tokenExpiresAt: now + 60 * 60 * 1000 };
};

export const refreshForgeRockToken = async (): Promise<string> => {
  const tokens: any = await TokenManager.getTokens({ forceRenew: true });
  if (!tokens?.accessToken) throw new Error('ForgeRock token refresh returned no access token');
  const timing = extractTokenTiming(tokens);
  store.dispatch(updateUserDetail({ token: tokens.accessToken, ...timing }));
  return tokens.accessToken;
};

export const validateToken = async (token: string): Promise<any> => {
  const validateTokenEndpoint = AM_URL + '/oauth2/alpha/introspect';
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  }
  const tokenValidationResponse = await axios.get(
    validateTokenEndpoint,
    options
  )
  return tokenValidationResponse
}

export const validateUserinSPAUAEPassFlow = async (body: any): Promise<any> => {
  const validateUserEndpoint = `${AM_URL}/json/realms/root/realms/alpha/authenticate?authIndexType=${FORGEROCK_AUTH_INDEX_TYPE}&authIndexValue=${FORGEROCK_SPA_AUTH_INDEX_VALUE}&flow=${FORGEROCK_DIGITALSPA_FLOW}`;
  const options = {
    headers: { 'Content-Type': 'application/json' }
  }
  const response = await axios.post(validateUserEndpoint, body, options);
  if(response?.data?.authId) {
    return response?.data;
  } else {
    return null;
  }
}